import {
    ACTION_UPDATE_CLIENT
} from './navigation.action';

const initialState = {
    client: {
        isConnected: false,
        isBank: false
    }
};

export const navigationReducer = (state = initialState, {type, payload = {}} = {}) => {
    const {client} = state;
    return type === ACTION_UPDATE_CLIENT ? {...state, client: {...client, ...payload.client}} : state;
};

export default navigationReducer;
